/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef, useState } from 'react';
import { OverlayTrigger } from 'react-bootstrap';
import Popover from 'react-bootstrap/Popover';
import { useTranslation } from 'react-i18next';
import AttachCreatePopOver from 'shared/attachment/AttachCreatePopOver';
import AttachEditPopOver from 'shared/attachment/AttachEditPopOver';
import { CreateActionsDropdown } from 'shared/dropdowns/CreateActionsDropdown';
import { useItem } from 'shared/dynamic-imports';
import { Button, IconDispatcher } from 'shared/ui-basics';
import styled, { css } from 'styled-components/macro';
import { decode, encode, getAttachMode } from 'utils/helpers';
import { InformationType } from 'utils/optionsSets/OptionSets';
import { v4 as uuidv4 } from "uuid";
import { deleteCxAttributeItem, getFileService, upsertCXAttributeAttachItem } from '../../redux/index';


type Props = {
    disabled: boolean;
    recordType: "cem_cxopportunity" | "cem_cxactiontask" | "cem_cxsolution";
}
interface AttachmentItem {
    id: string;
    description: string;
    fileName: string;
    url: string;
    uploadFile?: File;
}
export default function AttachPopover({
    disabled,
    recordType,
}: Props): JSX.Element {

    const refPopup = useRef<{ toggle: (e: any) => void } | null>(null);

    const { t } = useTranslation();
    const { currentItem, updateAttribute } = useItem();
    const [show, setShow] = useState(false);


    const [modifiedItem, setModifiedItem] = useState<AttachmentItem | null>(null);
    const [saveEvent, setSaveEvent] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);
    const attachementAttributes = currentItem?.attributes?.find((att: any) => att.type === InformationType.Attachment);


    const newObject: any = {
        id: uuidv4(),
        cxAttributeId: attachementAttributes.id,
        fileName: "",
        url: "",
        description: ""
    };
    const upsert = ({ newObject, onSuccess }: any) => {
        if (attachementAttributes.items.find((item: any) => item.id === newObject.id)) {
            // update
            const newValue = attachementAttributes.items.map((item: any) => item.id === newObject.id ? newObject : item);
            updateAttribute(attachementAttributes.id, "items", newValue)
        } else {
            // add
            const newValue = attachementAttributes.items ? [...attachementAttributes.items, newObject] : [newObject];
            updateAttribute(attachementAttributes.id, "items", newValue)
        }
        const formData = new FormData();
        const newItems = { ...newObject }
        newItems.url = encode(newItems.url);
        newItems.fileName = newItems.url === "" ? newItems.fileName : encode(newItems.fileName);
        newItems.description = encode(newItems.description);

        formData.append("cxAttributeItem", JSON.stringify(newItems));
        formData.append("objId", currentItem.id);
        formData.append("objName", recordType);

        const files = newItems?.uploadFile;
        if (files) {
            formData.append("uploadFile", files, decode(newItems?.fileName)); // Extracting the file name
        }

        upsertCXAttributeAttachItem({ data: formData, onSuccess })
    };
    const onRemove = (e: any, id: string) => {
        e.stopPropagation()

        const newAttachments = attachementAttributes?.items?.filter((item: any) => item.id !== id);
        updateAttribute(attachementAttributes.id, "items", newAttachments)
        deleteCxAttributeItem({ attributeItemId: id, attributeId: attachementAttributes.id, objId: currentItem.id, objName: recordType })
    };
    const onToggle = (e: any) => {
        e.stopPropagation()
        setSaveEvent(e)
        if (attachementAttributes?.items?.length === 0) {
            refPopup.current?.toggle(e)
            return
        }
        setShow(!show)

    };
    const handleGetFile = (item: any) => {
        getFileService({ name: item.description, itemId: item.id, objId: currentItem.id, objName: recordType })
    };
    const handleEdit = (e: any, item: any) => {
        e.preventDefault();
        e.stopPropagation();
        setModifiedItem(item)
        setShow(false)
        setOpenEdit(true)
    };
    const createActions = (item: any) => {
        const attachMode = getAttachMode(item);
        const actions = [];
        if (attachMode === "file")
            actions.push({ handleClick: () => handleGetFile(item), icon: "download", text: t("Download") });
        actions.push({ handleClick: (e: any) => handleEdit(e, item), icon: "edit", text: t("EDIT") })
        actions.push({ handleClick: (e: any) => onRemove(e, item.id), icon: "DELETE", text: t("ASPX_13") });


        return actions;
    };

    return (
        <Wrapper>
            <Container id='attach-panel' disabled={disabled} onClick={onToggle} >
                {attachementAttributes?.items?.length > 0 ? attachementAttributes?.items.map((item: any) => (<div key={item.id} >
                    <FlexCardBorder>
                        <div >{IconDispatcher(getAttachMode(item))}</div>
                        {getAttachMode(item) === "file" ? <div className='ellipsis'>{item.description}</div>
                            : <a className='link-attachement' href={item?.url} target="_blank" rel="noreferrer">{item?.description}</a>}

                    </FlexCardBorder>
                </div>))
                    : <Label>
                        <div>{t("EMPTY")}</div>
                    </Label>}

            </Container>
            <OverlayTrigger trigger="click" show={show} onToggle={() => setShow(!show)} rootClose placement="bottom"
                overlay={
                    <CustomPopover id="popover-contained">
                        {attachementAttributes?.items?.map((item: any) => (<div key={item.id} >
                            <Item>
                                <div className='d-flex align-items-center gap-2'>
                                    <div >{IconDispatcher(getAttachMode(item))}</div>
                                    {getAttachMode(item) === "file" ? <div className='ellipsis'>{item.description}</div>
                                        : <a className='link-attachement' href={item?.url} target="_blank" rel="noreferrer">{item?.description}</a>}
                                </div>
                                <CreateActionsDropdown
                                    id={item?.id}
                                    actions={createActions(item)}
                                    toggleButton={IconDispatcher("ACTION-DROPDOWN-HORIZONTAL")}
                                    autoClose={"outside" as any}
                                    handleOnSelect={(eventKey: any, e: any) => e.stopPropagation() as any}
                                    handleToggle={(show: any, e: any) => e?.originalEvent?.stopPropagation() as any}
                                    isicon="true"
                                    size="s"
                                    dropdownClasses=""
                                />
                            </Item>
                        </div>))}
                        <Button variant='dark-link' onClick={(e: any) => {
                            setShow(false)
                            refPopup.current?.toggle(saveEvent)
                        }}>
                            {IconDispatcher("PLUS", 'me-2')}
                            {t("ADD_MORE")}
                        </Button>
                    </CustomPopover>
                }>
                <div />
            </OverlayTrigger>
            <AttachCreatePopOver
                innerRef={refPopup}
                item={newObject}
                upsertAttachItem={upsert}
                width={520}
            />
            <AttachEditPopOver
                open={openEdit}
                setOpen={setOpenEdit}
                item={modifiedItem}
                upsertAttachItem={(newObject: any) => upsert({
                    newObject: {
                        ...newObject,
                        description: decode(newObject.description),
                        filename: decode(newObject.filename),
                        url: decode(newObject?.url)
                    },
                })}
            />
        </Wrapper>
    );
}


interface ContainerProps extends React.HTMLAttributes<HTMLDivElement> {
    ref?: React.RefObject<HTMLDivElement>;
    disabled?: boolean;
    fs?: number | string;
    fw?: string;
}

interface WrapperProps extends React.HTMLAttributes<HTMLDivElement> {
    ref?: React.RefObject<HTMLDivElement>;

}
const Container = styled.div<ContainerProps>`
	display: flex;
	align-items: center;
    flex-wrap: wrap;
	gap: 8px;
	width: 100%;
	min-height: 48px;
	border-radius: 4px;
	padding: 8px;

	cursor: pointer;
	:hover {
		background: #efefef;
	}
	${({ disabled }) =>
        disabled &&
        css`
            pointer-events: none;
			cursor: not-allowed;
		`}
`;

const Label = styled.div`
	display: flex;
	align-items: center;
	gap: 4px;
	color: #605f60;
	font-size: 14px;
`;
const Wrapper = styled.div<WrapperProps>`
    /* display: flex;
    align-items: center; */
    height: 100%;
    position: relative;
`;
const FlexCardBorder = styled.div`
    display: flex;
    align-items: center;
    padding : 4px;
    border-radius: 4px;
    gap: 8px;
    /* border:1px solid #c4c4c4 */
`;
const Item = styled.div`
display: flex;
width: 100%;
padding: 8px 16px;
justify-content: space-between;
align-items: center;
align-self: stretch;
color: var(--color-Grey-Primary-Text, #262626);
border-radius: var(--Radius-100, 4px);
border: var(--sds-size-stroke-border) solid var(--color-Grey-Dividers, #F0F0F0);
background: var(--white, #FFF);
`
const CustomPopover = styled(Popover)`
max-width: 520px;
width: 100%;
padding:8px;
gap:4px;
display: flex;
flex-direction: column;
box-shadow: 1px 8px 16px 0px rgba(0, 0, 0, 0.15);
/* align-items: center;
justify-content:start; */
button {
    justify-content: start;
}
`
